import { render, staticRenderFns } from "./OurValues.vue?vue&type=template&id=06bd949a&scoped=true&"
import script from "./OurValues.vue?vue&type=script&lang=js&"
export * from "./OurValues.vue?vue&type=script&lang=js&"
import style0 from "./OurValues.vue?vue&type=style&index=0&id=06bd949a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bd949a",
  null
  
)

export default component.exports